/**
 * Creates a response string to be used in a Web Worker.
 * Converts the provided worker function into a string that can be executed inside the worker context.
 *
 * @param func - The function to run inside the worker.
 * @returns A string representing the worker script.
 */
var createResponse = function (func) {
    return "self.onmessage = event => { \n    const args = event.data; \n    if (args) { \n      (".concat(func.toString(), ").call(null, self, args); \n    } \n  }");
};
/**
 * Creates a Web Worker from a provided function.
 *
 * @param func - The function to be executed by the worker.
 * @param windowObj - The global window object.
 * @returns The created Web Worker or undefined if Web Workers are not supported.
 */
export var createWebWorker = function (func, windowObj) {
    if (typeof windowObj !== 'undefined' &&
        'Worker' in windowObj &&
        ('URL' in windowObj || 'webkitURL' in windowObj)) {
        var workerConstructor = windowObj.Worker || Worker;
        if (workerConstructor) {
            var urlCreator = windowObj.URL || windowObj.webkitURL;
            var workerScript = createResponse(func);
            var blob = new Blob([workerScript], { type: 'application/javascript' });
            var workerURL = urlCreator.createObjectURL(blob);
            return new Worker(workerURL);
        }
    }
    return undefined;
};
